import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { Icon } from '@seeqdev/qomponents';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface PatternIF extends ValidatingFormComponent<string> {
  component: 'PatternFormComponent';
  min: number;
  max: number;
  label?: string;
}

export const PatternFormComponent = (props: PatternIF) => {
  const {
    name,
    testId = 'pattern',
    label,
    tooltip,
    min,
    max,
    validation,
    extendValidation,
    extraClassNames,
    customErrorText,
  } = props;

  const defaultValidation = (_value: string | undefined) => {
    return min === max;
  };

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  const { t } = useTranslation();
  const formState = useForm().getState();
  const showError = _.has(formState.errors, name) && formState.hasValidationErrors;
  const labelText = label ? t(label) : undefined;
  const tooltipText = tooltip ? t(tooltip) : undefined;

  return (
    <FormFieldWrapper
      testId={testId}
      extraClassNames={extraClassNames}
      showError={showError}
      customErrorText={customErrorText}>
      <Field<string> name={name} validate={appliedValidation}>
        {() => {
          return (
            <div className="flexColumnContainer">
              <div>{labelText}</div>
              {tooltip && (
                <Icon
                  icon="fa-question-circle"
                  large={true}
                  tooltip={tooltipText}
                  extraClassNames="text-interactive pl5"
                />
              )}
            </div>
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
